export const theme = {
    colors: {
        primary: {
            light: "#5A8DEE",
            main: "#175EE4",
        },
        gray: {
            light: "#e0e0e0",
            main: "#bdbdbd",
            dark: "#757575",
        },
        green: {
            light: "#C8F5DE",
            main: "#1E7148",
        },
        orange: {
            main: "#ff9800",
            dark: "#fb8c00",
        },
    },
};
